export const CHECKOUT_EXTRA_PAGE = 'CheckoutExtraPage';
export const CHECKOUT_PROPOSAL_PAGE = 'CheckoutProposalPage';
export const CHECKOUT_PAGE = 'CheckoutPage';
export const CONGRATS_ENQUIRY_PAGE = 'CongratsEnquiryPage';
export const CONGRATS_PROPOSAL_PAGE = 'CongratsProposalPage';